import { render, staticRenderFns } from "./snap02.vue?vue&type=template&id=2d7e2772"
import script from "./snap02.vue?vue&type=script&lang=js"
export * from "./snap02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports